module.exports = __webpack_public_path__ + "assets/droplet-divider.61d0fc82.svg";